import { useState } from 'react';
import AgTypography from '../../Styles/AgTypography';
import { useIntl } from 'react-intl';
import { AgColor } from '../../Styles/AgColor';

export interface AgToggleProps {
  checked?: boolean;
  disabled?: boolean;
  // eslint-disable-next-line no-unused-vars
  onChange?: Function;
}

const AgToggle = (
  {
    checked = false,
    disabled,
    onChange
  }: AgToggleProps
) => {
  const messages = useIntl().formatMessage;
  const [check, setCheck] = useState<boolean>(checked);
  const handleClick = () => {
    if (disabled) return;
    const newCheck = !check;
    setCheck(newCheck);
    if (onChange) {
      onChange(newCheck);
    }
  };

  return (
    <AgTypography
      style={{
        width: '56px',
        height: '24px',
        borderRadius: '20px',
        boxSizing: 'border-box',
        padding: '2px',
        display: 'flex',
        alignItems: 'center',
        flexDirection: check ? 'row' : 'row-reverse',
        gap: '6px',
        cursor: disabled ? 'default' : 'pointer',
        backgroundColor:
          disabled
            ? AgColor.grey4
            : check
              ? AgColor.secondaryMain
              : AgColor.grey5
      }}
      onClick={handleClick}
    >
      <AgTypography
        style={{
          width: '20px',
          height: '20px',
          borderRadius: '19px',
          backgroundColor: AgColor.grey1
        }}
      />
      <AgTypography
        contentStyle={'AP.H5.UPPERCASE.Medium'}
        message={messages({ id: check ? 'TOGGLE_YES' : 'TOGGLE_NO' })}
        style={{
          color: disabled ? AgColor.grey7 : AgColor.grey0
        }}
      />
    </AgTypography>
  );
};

export default AgToggle;